import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBooking, IBookingInitialState } from "./bookingModel";
import { getAllBookings } from "./services/booking.services";

const initialState: IBookingInitialState = {
  loading: false,
  error: "",
  BookingID: null,
  BookingList: [],
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setBookingID: (state, action) => {
      state.BookingID = action.payload;
    },
    clearBookingID: (state) => {
      state.BookingID = initialState.BookingID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBookings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBookings.fulfilled,
      (state, action: PayloadAction<IBooking[]>) => {
        state.loading = false;
        state.BookingList = action.payload || [];
      }
    );
    builder.addCase(getAllBookings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BookingList = [];
    });
  },
});

export const { clearBookingID, setBookingID } = bookingSlice.actions;
export default bookingSlice.reducer;
